import React from 'react';
import { getText, TEXT_KEY } from 'shared/utils/localization';
import ENVIRONMENT_VARIABLES from 'shared/utils/environmentVariables';
import CopySelector from 'shared/utils/copySelector';
import { LOGIN_ERROR_TYPE } from 'shared/utils/authFlow/constants';
import TermsModalWrapper from './TermsModalWrapper';
import {
  TermsContainer,
  TermsTextContainer,
  TermsUpdateScreenTextWrapper,
  TermsImageWrapper,
  TermsImage,
  TermsFooterWrapper,
  TermsUpdateButtonText,
  GeneralSignImModalTopSpace,
  SingInModalContainer,
  ModalButtonWrapper,
  ModalFooter,
} from '../styledComponents';
import TermsAndConditions from '../../TermsAndConditions';
import ImageBW from '../../ImageBoundsWrapper';
import Styles from '../styles';

export const DefaultTermsModal = props => {
  const {
    isVisible,
    closeModal,
    closeRetryModal,
    terms,
    activeCheckbox,
    nonActiveCheckbox,
    setTerms,
    onSubmit,
    activeBG,
    nonActiveBG,
    onFacebookActivate,
    onGoogleActivate,
    closeTermsModal,
    selectedTerms,
    checkSelectedTerms,
    error,
    socialError,
    socialErrorType,
    statusMessage,
    clientText,
  } = props;
  return (
    <>
      <TermsModalWrapper
        isVisible={isVisible}
        closeModal={() => closeTermsModal(closeModal)}
        title={
          selectedTerms === 'privacy' ? getText(TEXT_KEY.PRIVACY_POLICY) : getText(TEXT_KEY.TERMS_AND_CONDITIONS_TITLE)
        }
        zIndex={101}
      >
        <TermsContainer className="terms-container">
          <TermsTextContainer termsState={selectedTerms}>
            {!selectedTerms ? (
              <>
                <TermsUpdateScreenTextWrapper>
                  {getText(TEXT_KEY.CONFIRM_TERMS_AGREE)}
                  {clientText} {getText(TEXT_KEY.TERMS_AND_CONDITIONS)}.{getText(TEXT_KEY.MARKETING_CONSENT)}
                  {clientText}
                  {getText(TEXT_KEY.PRIVACY_POLICY_AGREE)}
                  {clientText}
                </TermsUpdateScreenTextWrapper>

                <div>
                  <TermsImageWrapper>
                    <TermsImage
                      src={require(asset`images/TermsAndConditions_Buttons/TermsConditions@3x.png`)}
                      alt=""
                      resizeMode={'contain'}
                      onClick={() => checkSelectedTerms('terms')}
                    />
                  </TermsImageWrapper>

                  <TermsImageWrapper>
                    <TermsImage
                      src={require(asset`images/TermsAndConditions_Buttons/PrivacyPolicy@3x.png`)}
                      alt=""
                      resizeMode={'contain'}
                      onClick={() => checkSelectedTerms('privacy')}
                    />
                  </TermsImageWrapper>
                </div>
              </>
            ) : (
              <TermsAndConditions
                docType={selectedTerms === 'privacy' ? getText(TEXT_KEY.POLICY) : getText(TEXT_KEY.TERMS)}
              />
            )}
          </TermsTextContainer>
        </TermsContainer>
        <TermsFooterWrapper className="terms-footer">
          <div className="accept-terms-container">
            <ImageBW
              source={terms ? activeCheckbox : nonActiveCheckbox}
              ibw={require(asset`Checkbox.ibw`)}
              style={{
                objectFit: 'contain',
              }}
              className="checkbox-image"
              onClick={setTerms}
            />
            <p qa-id="checkboxTermsAndConditions" className="accept-terms-text" onClick={setTerms}>
              {getText(TEXT_KEY.AGREE_TERMS)}
            </p>
          </div>
          <div qa-id="continueBtn" className="continue-button-container" onClick={terms ? onSubmit : null}>
            <ImageBW
              source={terms ? activeBG : nonActiveBG}
              ibw={require(asset`Continue_Button.ibw`)}
              style={{ objectFit: 'contain' }}
              className="continue-button"
              innerStyle={{
                cursor: 'pointer',
              }}
            >
              <div className="continue-button-content">
                <TermsUpdateButtonText termsState={terms} className="continue-button-text">
                  {getText(TEXT_KEY.CONTINUE_BUTTON)}
                </TermsUpdateButtonText>
              </div>
            </ImageBW>
          </div>
        </TermsFooterWrapper>
      </TermsModalWrapper>

      <TermsModalWrapper
        isVisible={!!error && !socialError}
        closeModal={closeModal}
        title={CopySelector.getCopy(CopySelector.COPY_TYPES.GENERIC_LOGIN_ERROR_TITLE)}
        zIndex={101}
        modalStyle={Styles.modalStyle}
        modalContainerStyle={Styles.modalContainerStyle}
        titleStyle={Styles.titleStyle}
      >
        <GeneralSignImModalTopSpace />
        <SingInModalContainer>
          <p className="verified-text">{CopySelector.getCopy(CopySelector.COPY_TYPES.GENERIC_LOGIN_ERROR_MESSAGE)}</p>
          <ModalButtonWrapper
            onClick={() => {
              closeModal();
              window.open(ENVIRONMENT_VARIABLES.ZENDESK_URL, '_blank');
            }}
          >
            <ImageBW
              source={activeBG}
              ibw={require(asset`Continue_Button.ibw`)}
              style={{ objectFit: 'contain' }}
              className="login-button"
              innerStyle={{
                cursor: 'pointer',
              }}
            >
              <div className="continue-button-content">
                <p className="login-button-text">{getText(TEXT_KEY.CONTACT_BUTTON)}</p>
              </div>
            </ImageBW>
          </ModalButtonWrapper>
          <ModalFooter />
        </SingInModalContainer>
      </TermsModalWrapper>
      <TermsModalWrapper
        isVisible={!!socialError && !error}
        closeModal={closeRetryModal}
        title={
          socialErrorType === LOGIN_ERROR_TYPE.FACEBOOK ? getText(TEXT_KEY.SHARE_EMAIL) : getText(TEXT_KEY.TRY_AGAIN)
        }
        zIndex={101}
        modalStyle={Styles.socialModalStyle}
        modalContainerStyle={Styles.SocialModalContainerStyle}
        titleStyle={Styles.titleStyle}
        modalMainBodyStyle={Styles.modalMainBodyStyle}
        disableClose
      >
        <SingInModalContainer>
          <p className="error-text">{typeof statusMessage === 'string' && statusMessage}</p>
          <ModalButtonWrapper
            onClick={() => {
              closeRetryModal();
              onGoogleActivate && socialErrorType === LOGIN_ERROR_TYPE.GOOGLE && onGoogleActivate();
              onFacebookActivate && socialErrorType === LOGIN_ERROR_TYPE.FACEBOOK && onFacebookActivate();
            }}
          >
            <ImageBW
              source={activeBG}
              ibw={require(asset`Continue_Button.ibw`)}
              style={{ objectFit: 'contain' }}
              className="continue-button"
              innerStyle={{
                cursor: 'pointer',
              }}
            >
              <div className="continue-button-content">
                <p className="continue-button-text">{getText(TEXT_KEY.RETRY_BUTTON)}</p>
              </div>
            </ImageBW>
          </ModalButtonWrapper>
          <ModalFooter />
        </SingInModalContainer>
      </TermsModalWrapper>
    </>
  );
};

